<div ngxSvgEditor style="border: solid rgba(0, 0, 0, 0.2) 1px; margin: auto;">
</div>